import React, { useRef, useState } from "react";
import { months } from "../../../Utilitie";
import DownloadExcel from "../../../Extra/DownloadExcel";

const tableHead = ["Wagon", "ML Ton", "Freight Cr"];

const EverBestMnthWiseSa = ({ data }) => {
  const tableRef = useRef();

  // Years
  const years = [...new Set(data.map((o) => o.F_YEAR))].sort(
    (a, b) => b.replace("_", "") - a.replace("_", ""),
  );

  const [sortConfig, setSortConfig] = useState({
    key: "WAGON",
    year: years[0],
    direction: "desc",
  });

  // Months
  const monthsInData = [...new Set(data.map((o) => o.A_MONTH))];

  // 🔹 Helper
  const getValue = (month, year, key) => {
    const filtered = data.filter(
      (o) =>
        o.F_YEAR === year &&
        o.A_MONTH.toLowerCase().slice(0, 3) === month.toLowerCase().slice(0, 3),
    );

    if (key === "WAGON") {
      return filtered.reduce((s, o) => s + (Number(o.WAGON) || 0), 0);
    }

    if (key === "CH_WEIGHT") {
      return (
        filtered.reduce((s, o) => s + (Number(o.CH_WEIGHT) || 0), 0) / 1000000
      );
    }

    if (key === "FREIGHT") {
      return (
        filtered.reduce((s, o) => s + (Number(o.FREIGHT) || 0), 0) / 10000000
      );
    }

    return 0;
  };

  const sortedMonths = [...monthsInData].sort((m1, m2) => {
    const val1 = getValue(m1, sortConfig.year, sortConfig.key);
    const val2 = getValue(m2, sortConfig.year, sortConfig.key);

    return sortConfig.direction === "asc" ? val1 - val2 : val2 - val1;
  });

  const displayMonths = sortedMonths.slice(0, 3);

  const handleSort = (head, year) => {
    const key =
      head === "Wagon" ? "WAGON" : head === "ML Ton" ? "CH_WEIGHT" : "FREIGHT";

    setSortConfig((prev) => ({
      key,
      year,
      direction:
        prev.key === key && prev.year === year && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const getIndicator = (head, year) => {
    const key =
      head === "Wagon" ? "WAGON" : head === "ML Ton" ? "CH_WEIGHT" : "FREIGHT";

    if (sortConfig.key === key && sortConfig.year === year) {
      return sortConfig.direction === "asc" ? " ↑" : " ↓";
    }
    return "";
  };

  return (
    <div className="fade-in-up">
      <div className="table-responsive">
        <table
          className="table newUiTable table-striped table-hover"
          ref={tableRef}
          style={{ fontSize: "11.5px", fontWeight: "bold" }}
        >
          <thead>
            <tr>
              <th rowSpan={2} style={{ width: "80px" }}>
                Sn
              </th>
              <th rowSpan={2} style={{ width: "100px" }}>
                Month
              </th>

              {years.map((year, i) => (
                <th colSpan={3} key={i}>
                  {year}
                </th>
              ))}
            </tr>

            <tr>
              {years.map((year, i) =>
                tableHead.map((head, j) => (
                  <th
                    key={j}
                    style={{
                      cursor: "pointer",
                      userSelect: "none",
                      minWidth: "90px",
                    }}
                    onClick={() => handleSort(head, year)}
                  >
                    {head}
                    {getIndicator(head, year)}
                  </th>
                )),
              )}
            </tr>
          </thead>

          <tbody>
            {displayMonths.map((month, k) => (
              <tr key={k}>
                <td>{k + 1}</td>
                <td>{month}</td>

                {years.map((y, a) => {
                  const yearWiseData = data.filter(
                    (o) =>
                      o.F_YEAR === y &&
                      o.A_MONTH.toLowerCase().slice(0, 3) ===
                        month.toLowerCase().slice(0, 3),
                  );

                  return (
                    <React.Fragment key={a}>
                      <td>
                        {yearWiseData.length > 0
                          ? yearWiseData.reduce(
                              (sum, obj) => sum + (Number(obj.WAGON) || 0),
                              0,
                            )
                          : "-"}
                      </td>

                      <td>
                        {yearWiseData.length > 0
                          ? (
                              yearWiseData.reduce(
                                (sum, obj) =>
                                  sum + (Number(obj.CH_WEIGHT) || 0),
                                0,
                              ) / 1000000
                            ).toFixed(2)
                          : "-"}
                      </td>

                      <td>
                        {yearWiseData.length > 0
                          ? (
                              yearWiseData.reduce(
                                (sum, obj) => sum + (Number(obj.FREIGHT) || 0),
                                0,
                              ) / 10000000
                            ).toFixed(2)
                          : "-"}
                      </td>
                    </React.Fragment>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <DownloadExcel tableRef={tableRef} fileName={`7A loading month wise`} />
    </div>
  );
};

export default EverBestMnthWiseSa;
